import { render, staticRenderFns } from "./AddFeedPurchase.vue?vue&type=template&id=5f607de0&"
import script from "./AddFeedPurchase.vue?vue&type=script&lang=js&"
export * from "./AddFeedPurchase.vue?vue&type=script&lang=js&"
import style0 from "./AddFeedPurchase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports